import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/index.css";
import "./i18n"; // initialise i18next before first render

const container = document.getElementById("root");
if (!container) throw new Error("Root element #root not found in index.html.");

createRoot(container).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
